import React, { useState, useEffect } from "react";
import StatsBarChart from "./StatsBarChart";

const Stats = (value) => {
  const mainDB = value.data.main_db;
  const descriptiveStats = value.data.main_db.descriptive_stats;

  const [questionIndex, setQuestionIndex] = useState(1);

  var closedQIndex = 0;
  const createClosedQIndex = () => {
    closedQIndex = closedQIndex + 1;
  };

  const createTableData = () => {
    var closedQCrosstabs = [];
    var closeQindex = 0;
    for (let i = 0; i < Object.keys(mainDB.questions).length; i++) {
      var closedQItem = mainDB.crosstabs.find(
        (e) =>
          e.question_column.number === i + 1 && e.question_row.number === i + 1
      );
      if (closedQItem.question_row.is_closed) {
        closedQCrosstabs[closeQindex] = closedQItem;
        closeQindex = closeQindex + 1;
      }
    }

    return closedQCrosstabs[questionIndex - 1];
  };

  const createSeries = () => {
    let mainSeriesData = [];
    let crossTabs = createTableData();

    if (crossTabs) {
      let columnLength = crossTabs.row_total_percents.length;
      let seriesTemp = [];
      let totalsSum = 0,
        totalPercentSum = 0,
        errorPercentSum = 0,
        underLimitSum = 0,
        upperLimitSum = 0;

      for (let i = 0; i < columnLength; i++) {
        let count = crossTabs.row_totals[i];
        let totalPercent = (crossTabs.row_total_percents[i] * 100).toFixed(1);
        let errorPercent = (crossTabs.row_errors[i] * 100).toFixed(1);
        let underLimit = Number(totalPercent) - Number(errorPercent);
        let upperLimit = Number(totalPercent) + Number(errorPercent);
        totalsSum = Number(totalsSum) + Number(crossTabs.row_totals[i]);
        totalPercentSum = Number(totalPercentSum) + Number(totalPercent);
        errorPercentSum = Number(errorPercentSum) + Number(errorPercent);
        underLimitSum =
          Number(underLimitSum) +
          Number(underLimit > 0 ? underLimit.toFixed(1) : 0);

        // series data
        let goalArray = [];
        goalArray.push({
          name: "MAX",
          value: upperLimit > 0 ? Number(upperLimit.toFixed(1)) : 0,
          strokeWidth: 15,
          strokeHeight: 0,
          strokeLineCap: "round",
          strokeColor: "#555",
        });
        goalArray.push({
          name: "MIN",
          value: underLimit > 0 ? Number(underLimit.toFixed(1)) : 0,
          strokeWidth: 15,
          strokeHeight: 0,
          strokeLineCap: "round",
          strokeColor: "#555",
        });

        let series = {
          x: crossTabs.question_row.answers[i].desc,
          y: Number(totalPercent).toFixed(1),
          count: Number(count).toFixed(0),
          error: Number(errorPercent).toFixed(1),
          goals: goalArray,
        };
        seriesTemp.push(series);
      }
      mainSeriesData = [{ data: seriesTemp }];
    }
    return mainSeriesData;
  };

  useEffect(() => {
    const radio_state = JSON.parse(localStorage.getItem("statsQIndex"));
    if (radio_state) setQuestionIndex(radio_state);
  }, []);

  return (
    <div>
      <div className="container">
        <div className="col-12">
          <div className="d-flex justify-content-center mt-4">
            {/* Descriptive Stats */}
            <div className="col-4">
              <select
                className="stats_questions form-control"
                style={{ fontSize: "16px" }}
                value={questionIndex}
                onChange={(e) => {
                  localStorage.setItem(
                    "statsQIndex",
                    JSON.stringify(e.target.value)
                  );
                  setQuestionIndex(e.target.value);
                }}
              >
                {mainDB.questions.map((item, index) => (
                  <>
                    {item.is_closed ? (
                      <>
                        <>{createClosedQIndex()}</>
                        <option key={index} value={closedQIndex}>
                          {item.desc}
                        </option>
                      </>
                    ) : null}
                  </>
                ))}
              </select>

              <div className="d-flex" style={{ marginTop: "19px" }}>
                <div style={{ border: "solid 1px #dfdfdf" }}>
                  <div
                    className="pl-2 pr-2"
                    style={{ borderBottom: "solid 1px #dfdfdf" }}
                  >
                    <div>Question #</div>
                    <div>N. of Classes</div>
                    <div>Missing answers</div>
                    <div>Interviews</div>
                    <div>Expected class frequency</div>
                  </div>
                  <div
                    className="pl-2 pr-2"
                    style={{ borderBottom: "solid 1px #dfdfdf" }}
                  >
                    <div>Mean</div>
                    <div>Standard deviation</div>
                    <div>Standard error</div>
                    <div>HHI-Score</div>
                  </div>
                  <div
                    className="pl-2 pr-2"
                    style={{ borderBottom: "solid 1px #dfdfdf" }}
                  >
                    <div>Min</div>
                    <div>1st Quartile</div>
                    <div>Median</div>
                    <div>3rd Quartile</div>
                    <div>Max</div>
                  </div>
                  <div
                    className="pl-2 pr-2"
                    style={{ borderBottom: "solid 1px #dfdfdf" }}
                  >
                    <div>Kurtosis</div>
                    <div>Skewness</div>
                    <div>Mode</div>
                  </div>
                  <div className="pl-2 pr-2">
                    <div>Sum</div>
                  </div>
                </div>

                <div
                  className="border-left-0"
                  style={{ border: "solid 1px #dfdfdf" }}
                >
                  <div
                    className="pl-2 pr-2 text-center"
                    style={{ borderBottom: "solid 1px #dfdfdf" }}
                  >
                    <div>Q{questionIndex}</div>
                    <div>
                      {descriptiveStats.classes_amts[questionIndex - 1]}
                    </div>
                    <div>
                      {descriptiveStats.missing_amts[questionIndex - 1]}
                    </div>
                    <div>{descriptiveStats.observs[questionIndex - 1]}</div>
                    <div>
                      {Number(
                        descriptiveStats.expected_class_freqs[questionIndex - 1]
                      ).toFixed(2)}
                      %
                    </div>
                  </div>
                  <div
                    className="pl-2 pr-2 text-center"
                    style={{ borderBottom: "solid 1px #dfdfdf" }}
                  >
                    <div
                      style={
                        Number(
                          descriptiveStats.means[questionIndex - 1]
                        ).toFixed(2) > 0
                          ? { color: "#000000" }
                          : { color: "#ff0000" }
                      }
                    >
                      {Number(
                        descriptiveStats.means[questionIndex - 1]
                      ).toFixed(2)}
                    </div>
                    <div
                      style={
                        Number(
                          descriptiveStats.stds[questionIndex - 1]
                        ).toFixed(2) > 0
                          ? { color: "#000000" }
                          : { color: "#ff0000" }
                      }
                    >
                      {Number(descriptiveStats.stds[questionIndex - 1]).toFixed(
                        2
                      )}
                    </div>
                    <div
                      style={
                        Number(
                          descriptiveStats.standard_errors[questionIndex - 1]
                        ).toFixed(2) > 0
                          ? { color: "#000000" }
                          : { color: "#ff0000" }
                      }
                    >
                      {Number(
                        descriptiveStats.standard_errors[questionIndex - 1]
                      ).toFixed(2)}
                    </div>
                    <div
                      style={
                        Number(
                          descriptiveStats.hhi_scores[questionIndex - 1]
                        ).toFixed(2) > 0
                          ? { color: "#000000" }
                          : { color: "#ff0000" }
                      }
                    >
                      {Number(
                        descriptiveStats.hhi_scores[questionIndex - 1]
                      ).toFixed(2)}
                    </div>
                  </div>
                  <div
                    className="pl-2 pr-2 text-center"
                    style={{ borderBottom: "solid 1px #dfdfdf" }}
                  >
                    <div>
                      {descriptiveStats.quartiles.min[questionIndex - 1]}
                    </div>
                    <div>
                      {descriptiveStats.quartiles.first[questionIndex - 1]}
                    </div>
                    <div>
                      {descriptiveStats.quartiles.median[questionIndex - 1]}
                    </div>
                    <div>
                      {descriptiveStats.quartiles.third[questionIndex - 1]}
                    </div>
                    <div>
                      {descriptiveStats.quartiles.max[questionIndex - 1]}
                    </div>
                  </div>
                  <div
                    className="pl-2 pr-2 text-center"
                    style={{ borderBottom: "solid 1px #dfdfdf" }}
                  >
                    <div
                      style={
                        Number(
                          descriptiveStats.kurtosises[questionIndex - 1]
                        ).toFixed(2) > 0
                          ? { color: "#000000" }
                          : { color: "#ff0000" }
                      }
                    >
                      {Number(
                        descriptiveStats.kurtosises[questionIndex - 1]
                      ).toFixed(2)}
                    </div>
                    <div
                      style={
                        Number(
                          descriptiveStats.skewnesses[questionIndex - 1]
                        ).toFixed(2) > 0
                          ? { color: "#000000" }
                          : { color: "#ff0000" }
                      }
                    >
                      {Number(
                        descriptiveStats.skewnesses[questionIndex - 1]
                      ).toFixed(2)}
                    </div>
                    <div>{descriptiveStats.modes[questionIndex - 1]}</div>
                  </div>
                  <div className="pl-2 pr-2 text-center">
                    <div>{descriptiveStats.sums[questionIndex - 1]}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6">
              <div className="d-flex justify-content-end mt-4">
                <a
                  className="help-link"
                  href="#!"
                  onClick={
                    () => window.parent.postMessage({
                      cmd: "hyperlink",
                      url: "https://logratio.com/users-guide/#descriptive-statistics"
                    }, "https://logratio.com")
                  }
                >
                  Help with this analysis
                </a>
              </div>

              {/* Table data */}
              <table className="mt-3 stats_table">
                <thead>
                  <tr>
                    <th className="col-4">Answer class</th>
                    <th className="col-1">Counts</th>
                    <th className="col-1">%</th>
                    <th className="col-3">Error(x +/- %)</th>
                    <th className="col-3">% +/- Error</th>
                  </tr>
                </thead>
                <tbody>
                  {createTableData().row_totals.map((item, index) => (
                    <tr key={index}>
                      <th>
                        {" "}
                        {
                          createTableData().question_column.answers[index].desc
                        }{" "}
                      </th>
                      <td>{item}</td>
                      <td>
                        {" "}
                        {Number(
                          createTableData().row_total_percents[index] * 100
                        ).toFixed(1)}
                        %
                      </td>
                      <td>
                        {" "}
                        {Number(
                          createTableData().row_errors[index] * 100
                        ).toFixed(1)}
                        %
                      </td>
                      <td>
                        {Number(
                          createTableData().row_total_percents[index] * 100 -
                          createTableData().row_errors[index] * 100
                        ).toFixed(1) > 0
                          ? Number(
                            createTableData().row_total_percents[index] *
                            100 -
                            createTableData().row_errors[index] * 100
                          ).toFixed(1)
                          : 0}
                        ~
                        {Number(
                          createTableData().row_total_percents[index] * 100 +
                          createTableData().row_errors[index] * 100
                        ).toFixed(1) > 0
                          ? Number(
                            createTableData().row_total_percents[index] *
                            100 +
                            createTableData().row_errors[index] * 100
                          ).toFixed(1)
                          : 0}
                        %
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <th>Sum</th>
                    <td>{Number(createTableData().grand_total)}</td>
                    <td> 100% </td>
                  </tr>
                </tbody>
              </table>

              <div className="mt-3 d-flex">
                <div
                  className="table_th_top"
                  style={{ fontSize: "16px", height: "210px" }}
                >
                  <strong>N. of Classes</strong>
                </div>
                <StatsBarChart
                  key={questionIndex}
                  series={createSeries()}
                  question={createTableData().question_row.desc}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stats;
